export default __webpack_public_path__ + "static/media/table-share-icon.a089d6bc.svg";